import { motion } from 'framer-motion';
import { useTranslation } from '../../context/LanguageContext';
import { homeTestimonialImage } from '../../assets/siteImages';
import { fadeUp, scrollViewport } from '../../motion/presets';
import './home-testimonial.scss';

const HomeTestimonial = () => {
  const { content } = useTranslation();
  const t = content.home.testimonial;

  return (
    <section className="home-testimonial section-full" aria-labelledby="home-testimonial-title">
      <div className="container">
        <motion.div
          className="home-testimonial__card surface-muted"
          initial="hidden"
          whileInView="visible"
          viewport={scrollViewport}
          variants={fadeUp}
        >
          <div className="home-testimonial__inner">
            <figure className="home-testimonial__media">
              <img
                className="home-testimonial__photo"
                src={homeTestimonialImage}
                alt={t.photoAlt}
                loading="lazy"
                decoding="async"
              />
            </figure>
            <div className="home-testimonial__copy">
              <p className="home-testimonial__kicker">{t.kicker}</p>
              <h2 id="home-testimonial-title" className="home-testimonial__title">
                {t.title}
              </h2>
              <blockquote className="home-testimonial__quote">
                <p>{t.quote}</p>
              </blockquote>
              <footer className="home-testimonial__cite">
                <strong>{t.author}</strong>
                <span className="home-testimonial__sep"> · </span>
                {t.location}
                <span className="home-testimonial__meta">{t.detail}</span>
              </footer>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HomeTestimonial;
